"use strict";
// tslint:disable
// eslint-disable
/**
 * Roles and Rights API
 * API for configurable roles and rights
 *
 * The version of the OpenAPI document: 1.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var runtime_1 = require("../runtime");
function RoleFromJSON(json) {
    return RoleFromJSONTyped(json, false);
}
exports.RoleFromJSON = RoleFromJSON;
function RoleFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !runtime_1.exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'isDefault': json['isDefault'],
        'rights': json['rights'],
        'createdAt': !runtime_1.exists(json, 'createdAt') ? undefined : json['createdAt'],
        'numberOfUsers': json['numberOfUsers'],
        'defaultSortOrder': !runtime_1.exists(json, 'defaultSortOrder') ? undefined : json['defaultSortOrder'],
    };
}
exports.RoleFromJSONTyped = RoleFromJSONTyped;
function RoleToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'isDefault': value.isDefault,
        'rights': value.rights,
        'createdAt': value.createdAt,
        'numberOfUsers': value.numberOfUsers,
        'defaultSortOrder': value.defaultSortOrder,
    };
}
exports.RoleToJSON = RoleToJSON;
